import { render, staticRenderFns } from "./SecondaryGreenButton.vue?vue&type=template&id=da4bfad6&scoped=true&"
import script from "./SecondaryGreenButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryGreenButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryGreenButton.vue?vue&type=style&index=0&id=da4bfad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4bfad6",
  null
  
)

export default component.exports